// Centered explanation for an empty page or panel, with at most one next step.
export function EmptyState({ icon: Icon, title, text, action, compact = false }) {
  return (
    <div className={`flex flex-col items-center text-center ${compact ? 'py-8 px-4' : 'py-14 px-6'}`}>
      {Icon && (
        <span className="w-11 h-11 rounded-[12px] grid place-items-center" style={{ background: 'var(--accentSoft)', color: 'var(--accent)' }}>
          <Icon size={20} />
        </span>
      )}
      <p className="mt-3 text-base font-bold" style={{ color: 'var(--text)' }}>{title}</p>
      {text && <p className="mt-1 text-sm max-w-sm" style={{ color: 'var(--textMuted)' }}>{text}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}
